<template>
    <ModalComponent
        name="test-venta-warning"
        title="ENLACE PARA USO INTERNO"
        v-on:close="() => close(false)"
    >
        <template>
            <div class="row">
                <div class="col-12 mb-3">
                    <p class="text-justify text-lg" style="word-spacing: -2px;">
                        Este enlace es solo para uso interno.
                        No se debe publicar en ningún sitio web ni debe distribuirse al público general.
                    </p>
                </div>
                <div class="col-12">
                    <div class="d-flex justify-content-center">
                        <Button type="submit" name="button" class="btn btn-primary" @click="openLink">
                            De acuerdo, ir al enlace
                        </Button>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            link: String,
        },
        methods: {
            close() {
                this.$emit('close', 'test-venta-warning');
            },
            openLink() {
                this.$router.push(this.link);
            }
        },
        components: {
            ModalComponent
        },
    }
</script>
